import * as React from "react";

const RightArrowLongIcon: React.FC = () => {
    return (
        <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.20457 11.5797C1.64437 11.1399 2.35629 11.1406 2.79539 11.5797L5.37498 14.1602V1.12427C5.37498 0.502353 5.87806 -0.000732422 6.49998 -0.000732422C7.12189 -0.000732422 7.62498 0.502353 7.62498 1.12427V14.1602L10.2047 11.5804C10.6442 11.141 11.3561 11.141 11.7956 11.5804C12.235 12.0199 12.235 12.7318 11.7956 13.1713L7.29556 17.6713C6.85611 18.1107 6.1442 18.1107 5.70474 17.6713L1.20474 13.1713C0.765115 12.7293 0.765115 12.0192 1.20457 11.5797Z" fill="#8F0446"/>
        </svg>        

    );
};

export default React.memo(RightArrowLongIcon);
